interface MapByObjectId<T> {
  [objectId: string]: T;
}

interface MapById<T> {
  [id: string]: T;
}

interface BuilderFunc<T> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (keyGetter: KeyGetterFunc, map: MapById<T> | MapByObjectId<T>, value: any): any;
}

interface KeyGetterFunc {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (value: any): any;
}

const listToMapBy = <T>(
  list: T[],
  keyGetter: KeyGetterFunc,
  builder: BuilderFunc<T>,
): MapById<T> | MapByObjectId<T> =>
  list.reduce(
    (map, obj) => ({
      ...map,
      [keyGetter(obj)]: builder(keyGetter, map, obj),
    }),
    {},
  );

const listToMapByObjectId = <T extends HasObjectId>(list: T[]): MapByObjectId<T> =>
  listToMapBy<T>(
    list,
    (obj: T) => obj.objectId,
    (_0, _1, obj) => obj,
  );

const listToMapById = <T extends HasId>(list: T[]): MapById<T> =>
  listToMapBy(
    list,
    (obj: T) => obj.id,
    (_0, _1, obj) => obj,
  );

const shuffle = <T>(list: T[]): T[] =>
  list.reduce(
    ({ originalList, shuffledList }: { originalList: T[]; shuffledList: T[] }) => {
      shuffledList.push(originalList.splice(Math.floor(Math.random() * originalList.length), 1)[0]);
      return { originalList, shuffledList };
    },
    { originalList: [...list], shuffledList: [] },
  )['shuffledList'];

export { listToMapById, listToMapByObjectId, shuffle };
